import i18n from '@/lang';
import { getTeamMember } from '@/utils/common';
import { cloudApi, requestHttp } from '@/utils/index';

const state = {
  hasLogin: false,
  userInfo: null,
  teamMember: null
};

const mutations = {
  SET_LOGIN(state, payload) {
    state.hasLogin = payload;
    sessionStorage.setItem('hasLogin', payload);
  },

  SET_TEAM_MEMBER(state, payload) {
    state.teamMember = payload;
  },

  CLEAR_TOKEN() {
    // state.access_token = null;
    state.hasLogin = false;
    //直接clear会导致所有得sessionStorage被清除，造成父框架得数据丢失
    //sessionStorage.clear();
    sessionStorage.removeItem('hasLogin');
  },

  SET_USER_INFO(state, payload) {
    state.userInfo = payload;
  },

  SET_TENANT_INFO(state, payload) {
    state.tenantInfo = payload;
  }
};

const actions = {
  //获取用户登录信息
  getUserInfo({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      var data = {
        api: cloudApi.ACCOUNT_INFO,
        method: 'GET'
      };
      requestHttp(data)
        .then(res => {
          if (res && res.code == 0) {
            commit('SET_LOGIN', true);
            commit('SET_USER_INFO', res);

            const languageObjMap = {
              cn: 'zh',
              eseu: 'esEu'
            };
            let language = '';

            if (res.language) {
              language = languageObjMap[res.language] || res.language;
            } else {
              language = process.env.VUE_APP_CLOUD_DEFAULT_LANGUAGE;
            }
            dispatch('setLang', language, { root: true });
            window.localStorage.setItem('lang', language);

            // let server_sub = 'dev-cloud';

            // if (window.location.href.indexOf('cloud-us.lysoratech.com') > 0) {
            //   server_sub = 'cloud';
            // }

            // if (window.location.href.indexOf('cloud-') > 0 || window.location.href.indexOf('demotest') > 0) {
            //   if (window.location.href.indexOf('demotest') > 0) {
            //     server_sub = 'dev-macc_oversea';
            //   } else {
            //     server_sub = 'macc_oversea';
            //   }
            // }

            // window.sensors.login(res.accountId);
            // window.sensors.setProfile({
            //   ...res,
            //   project: server_sub
            // });
            resolve();
          } else {
            reject({
              msg: res?.msg || i18n.t('user.getUserMsgFail')
            });
          }
        })
        .catch(error => {
          reject({
            msg: i18n.t('user.getUserMsgFail') + `:${JSON.stringify(error)}`
          });
        });
    });
  },
  getTeam({ commit }) {
    return new Promise((resolve, reject) => {
      getTeamMember()
        .then(res => {
          if (res && res.code == 0) {
            commit(
              'SET_TEAM_MEMBER',
              res.data || {
                teamMember: {
                  teamRole: ''
                },
                team: {
                  teamType: ''
                }
              }
            );
            resolve();
          } else {
            reject({
              msg: res?.msg || i18n('user.getUserMsgFail2')
            });
          }
        })
        .catch(error => {
          reject({
            msg: i18n('user.getUserMsgFail2') + `:${JSON.stringify(error)}`
          });
        });
    });
  }
};

const getters = {
  //获取用户类型
  teamType: state => {
    const { teamMember = {} } = state;
    const { team = {} } = teamMember;
    const { teamType } = team;
    return teamType;
  }
};

export default {
  namespaced: true, //开启命名空间，更好的区分使用stage,防止不同stage模块中的方法重名
  state,
  getters,
  mutations,
  actions
};
